export default class UserAgent {
    constructor() {
        this.ua = navigator.userAgent.toLowerCase();
        this.isChrome = this.match('chrome');
        this.isExplorer = this.match('msie');
        this.isSafari = this.match('safari');
        if (this.isChrome && this.isSafari) {
            this.isSafari = false;
        }
        this.isIphoneNoticeDisabled = false;
        this.hasTouch = ('ontouchstart' in window);
        this.isAndroid = this.match('android');
        this.isWindowsPhone = this.match('windows phone');
        this.isTablet = (!this.match('mobile') && this.isAndroid) || this.isIpad;
        this.isMacOSx = this.match('macintosh');
        this.isMobile = (this.isSafari && !this.isMacOSx) || this.isAndroid || this.isIpad || this.isIphone || this.isWindowsPhone;
        this.isIpad = this.match('ipad') || this.isIpadInDesktopMode();
        this.isIphone = this.match('iphone') && !this.isWindowsPhone;
        this.isIos = this.isIpad || this.isIphone;
    }
    isIpadInDesktopMode() {
        return this.hasTouch && this.isMacOSx;
    }
    hasNoOpenerSupport() {
        return !this.isExplorer && !this.match('edge');
    }
    shouldUseApp() {
        return this.iphoneOsVersion() < 10;
    }
    iphoneOsVersion() {
        const regex = /iphone os (\d+)/i;
        const match = regex.exec(this.ua);
        if (match !== null) {
            if (match.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            const versionString = match[1];
            if (!versionString) {
                return -1;
            }
            return parseInt(String(versionString));
        }
        return -1;
    }
    isIphoneApp() {
        return this.isIphone && this.isIphoneNoticeDisabled;
    }
    shouldHideInteractiveLayer() {
        if (this.isIphone) {
            return !this.shouldUseApp() || this.iPhoneCanPlayInFacebookApp();
        }
        return this.isIpad || this.isAndroid;
    }
    iPhoneCanPlayInFacebookApp() {
        return this.isIphone && this.isIphoneFacebookApp() && !this.shouldUseApp();
    }
    isIphoneFacebookApp() {
        return !!this.ua.match(/(FBAN|FBAV)/gi);
    }
    hasMouse() {
        return matchMedia('(hover:hover)').matches;
    }
    match(testString) {
        return this.ua.includes(testString);
    }
    disableIphoneNotice() {
        this.isIphoneNoticeDisabled = true;
    }
    isBot() {
        const ignoreList = [
            'Baiduspider',
            'DuckDuckBot',
            'Googlebot',
            'AdsBot',
            'GoogleOther',
            'bingbot',
            'Slurp',
            'LinkedInBot',
            'msnbot',
            'Twitterbot',
            'Yandex',
            'phpcrawl',
            'Nutch',
            'speedy',
            'yacybot',
            'AISearchBot',
            'spbot',
            'Adidxbot',
            'Outlook',
        ];
        return ignoreList.some(bot => this.match(bot));
    }
}
